module.exports = __webpack_public_path__ + "img/next_invest_wealth.2b228e94.png";